<template>
    <md-tooltip
        class="message-container"
        md-direction="top"
        v-if="(ruleData && isTeamOwner && rateText.length > 0) && (rate.isBaseCharge && rateIndex === 0)"
    >
        <div v-for="(text, index) in rateText" :key="index">
            {{ text }}
        </div> 
    </md-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralMixin, RatesEngineMixin } from '@/mixins';

export default {
    name: 'RateChargeRule',
    components: {},
    mixins: [GeneralMixin, RatesEngineMixin],
    props: {
        ruleData: {
            type: Object,
            default: () => {}
        },
        currency: {
            type: String,
            default: "A$"
        },
        rate: {
            type: Object,
            default: () => {}
        },
        rateIndex: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            rateText: []
        };
    },
    mounted() {
        if (this.ruleData) {
            const currencyFilter = this.$options.filters.currency;
            const formattedCurrency = currencyFilter(null, this.currencyCode, true);
            this.rateText = this.$_getRateRuleText(this.ruleData, formattedCurrency, this.rate.type);        
        }
    },
    computed: {
        ...mapGetters({
            isTeamOwner: 'user/isTeamOwner',
        })
    },
};
</script>

<style lang="scss" scoped>
.message-container {
    margin: 10px !important;
    max-width: 550px !important;
}
</style>
